module.exports = __webpack_public_path__ + "img/edit_icon.f8b70d30.svg";